import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';


export default class ProductOnboard extends Component {
	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Product Onboard
					</div>
					<div className="top-thirty">
						<FileUploader url="ingest/product/onboard"/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SpaceOperations/Components/ProductOnboard.js